<template>
  <div>
    <shop-header :store-id="storeid" />
    <form @submit.prevent="placeOrder">
      <div class="container main-container">
        <div class="row">
          <div class="col-sm-7 col-xl-8">
            <div
              class="bg-white py-4 mb-2 position-relative"
              :style="getCheckoutRolldStyles()"
            >
              <payment-indicator
                v-if="showPaymentIndicator"
                :is-pending="proccessing"
                :succeeded="paymentSucceeded"
                @hide="hidePaymentIndicator"
                :is-pay-later="placingPayLaterOrder"
              ></payment-indicator>
              <!--              <div-->
              <!--                v-if="!user && viewConfig.LogIn"-->
              <!--                class="alert alert-primary p-4 mt-4 alert-color mx-4"-->
              <!--                :style="desktopStyles.alertInfoBackGround"-->
              <!--                role="alert"-->
              <!--              >-->
              <!--                <a-->
              <!--                  href="#"-->
              <!--                  :style="desktopStyles.btn"-->
              <!--                  class="btn btn-primary pr-2"-->
              <!--                  @click="setShowOverlay(true)"-->
              <!--                  >{{ $t("message.login") }}</a-->
              <!--                >-->
              <!--                <span-->
              <!--                  class="pl-2 rolld-primary-color"-->
              <!--                  style="vertical-align: middle"-->
              <!--                  >{{-->
              <!--                    $t("message.placeAnOrderAsGuestWithoutCreatingAccount")-->
              <!--                  }}</span-->
              <!--                >-->
              <!--              </div>-->

              <div class="p-4 d-flex justify-content-center">
                <div class="w-85">
                  <h4 v-show="showGettingYourMealMessage()">
                    {{ $t("message.gettingYourOrder") }}
                  </h4>
                  <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      v-show="isEnableTab('delivery')"
                      :style="btnStyle(isDelivery, false)"
                      type="button"
                      class="btn screamer-font"
                      @click="deliveryMode"
                    >
                      {{ $t("message.checkoutDelivery") }}
                    </button>
                    <h3
                      v-if="isEnableTab('pickUp') && isRolldStore()"
                      class="screamer-font"
                      style="margin-top: 10px; margin-right: 12px"
                    >
                      |
                    </h3>
                    <button
                      v-if="isEnableTab('pickUp')"
                      :style="btnStyle(isPickup, false)"
                      type="button"
                      class="btn screamer-font"
                      @click="pickupMode"
                    >
                      {{ $t("message.pickUp") }}
                    </button>
                    <h3
                      v-if="isEnableTab('deliverToRoom') && isRolldStore()"
                      class="screamer-font"
                      style="margin-top: 10px; margin-right: 12px"
                    >
                      |
                    </h3>
                    <button
                      v-if="isEnableTab('deliverToRoom')"
                      :style="btnStyle(isChargeToRoom, false)"
                      type="button"
                      class="btn screamer-font"
                      @click="chargeToRoomMode"
                    >
                      {{ $t("message.deliverToRoom") }}
                    </button>
                    <h3
                      v-if="isEnableTab('dineIn') && isRolldStore()"
                      class="screamer-font"
                      style="margin-top: 10px; margin-right: 12px"
                    >
                      |
                    </h3>
                    <button
                      v-if="isEnableTab('dineIn')"
                      :style="btnStyle(isEatIn, false)"
                      type="button"
                      class="btn screamer-font"
                      @click="eatInMode"
                    >
                      {{ $t("message.dineIn") }}
                    </button>
                  </div>

                  <pickup-address v-show="showPickupAddress()" />
                  <my-detail
                    v-if="!selectedCompany.ChargeToRoom && !isEatIn"
                    ref="myDetails"
                    :edit-model="detailModel"
                    :charge-to-room="selectedCompany.ChargeToRoom"
                    @save-user="saveUser(true)"
                    :for-gift="false"
                    :displayEmailField="displayEmailField"
                    :display-mobile-field="displayMobileField"
                    :disableNameField="disableNameField"
                  />
                  <delivery-address
                    v-if="isDelivery && googleLoaded"
                    ref="deliveryAddress"
                    :edit-model="deliveryAddressModel"
                    :show-estimate="!isPreOrder || isRolldStore()"
                    @postalCodeUpdate="updatePostalCodeHandler"
                    @estimationUpdated="
                      (newAddress) =>
                        setDeliveryTimes(
                          deliveryDate,
                          true,
                          false,
                          newAddress ? null : selectedDeliveryTime
                        )
                    "
                  />

                  <div
                    v-show="isDeliveryUnavailable"
                    class="order-type-address-error"
                  >
                    {{ deliveryUnavailableMessage }}
                  </div>
                  <div
                    v-show="!isChargeToRoom && (isDelivery || isPickup)"
                    class="form-row mt-4"
                  >
                    <div
                      class="form-group col-6"
                      v-if="
                        selectedCompany.EnablePreoderForDelivery && isDelivery
                      "
                    >
                      <label class="required">{{
                        $t("message.deliveryDate")
                      }}</label>
                      <date-picker
                        name="deliveryDT"
                        @closed="deliveryDateChanged(deliveryDate)"
                        v-model="deliveryDate"
                        :disabledDates="deliveryDisabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div
                      class="form-group col-6"
                      v-if="selectedCompany.EnablePreoderForPickup && isPickup"
                    >
                      <label class="required">{{
                        $t("message.pickupDate")
                      }}</label>
                      <date-picker
                        name="pickupDT"
                        @closed="
                          setPickupTimes(pickupDate, false, selectedPickupTime)
                        "
                        v-model="pickupDate"
                        :disabledDates="pickupDisabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div
                      v-show="isDelivery && isRolldStore()"
                      class="form-group col-6"
                    >
                      <label class="required" for="dtime-select">{{
                        $t("message.deliveryTime")
                      }}</label>
                      <vselect
                        name="dtime-select"
                        :options="dtimes"
                        :searchable="false"
                        :clearable="false"
                        v-model="selectedDeliveryTime"
                        label="format"
                        :reduce="(slot) => slot.to"
                        @input="
                          selectedDeliveryTimeChange(selectedDeliveryTime)
                        "
                      >
                      </vselect>
                      <div class="invalid-feedback">
                        {{
                          OOErrors.first("deliveryTime")
                            | inputNameLocale("deliveryTime")
                        }}
                      </div>
                    </div>
                    <div v-show="isPickup" class="form-group col-6">
                      <label class="required" for="time-select">{{
                        $t("message.pickupTime")
                      }}</label>
                      <vselect
                        name="time-select"
                        :options="pickupTimes"
                        :searchable="false"
                        :clearable="false"
                        v-model="selectedPickupTime"
                        label="format"
                        :reduce="(slot) => slot.time"
                        @input="selectedPickupTimeChange(selectedPickupTime)"
                      >
                      </vselect>
                      <div class="invalid-feedback">
                        {{
                          OOErrors.first("pickupTime")
                            | inputNameLocale("pickupTime")
                        }}
                      </div>
                    </div>
                  </div>
                  <label
                    v-show="isDelivery && !isRolldStore()"
                    class="required"
                    for="time-select"
                    >{{ $t("message.deliveryTime") }}</label
                  >
                  <div v-show="isDelivery && !isRolldStore()" class="form-row">
                    <button
                      class="btn time-slot-btn asap"
                      style="padding: 4px"
                      v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') >= 0
                      )"
                      :key="timeSlot + index"
                      @click="timeSlotsClick(timeSlot)"
                      :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                      :disabled="getDeliveryIsLoading"
                    >
                      <span>ASAP</span>
                      <br />
                      <span>{{
                        timeSlot.format.split("(")[1].split(")")[0]
                      }}</span>
                    </button>
                    <button
                      type="button"
                      class="btn time-slot-btn"
                      v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') < 0
                      )"
                      :key="index"
                      @click="timeSlotsClick(timeSlot)"
                      :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                      :disabled="getDeliveryIsLoading"
                    >
                      {{ timeSlot.format }}
                    </button>
                  </div>
                  <room-delivery
                    v-if="isChargeToRoom"
                    ref="roomDelivery"
                    :edit-model="roomDeliveryModel"
                  />
                  <eat-in
                    ref="eatIn"
                    @save-user="saveUser"
                    v-if="isEatIn"
                    :edit-model="eatInModel"
                    :is-pay-by-card="isPayByCard"
                  ></eat-in>
                  <div>
                    <div class="form-row" v-show="viewConfig.ShowNotes">
                      <div class="form-group col-sm-12">
                        <div class="d-flex">
                          <h4>
                            {{ $t("message.notes") }}
                          </h4>
                          <b-icon-plus
                            style="margin-top: -1px"
                            v-if="!notesVisible"
                            @click="notesVisible = true"
                          ></b-icon-plus>
                          <b-icon-dash
                            style="margin-top: -1px"
                            v-else
                            @click="notesVisible = false"
                          ></b-icon-dash>
                        </div>
                        <b-collapse id="collapse-2" v-model="notesVisible">
                          <textarea
                            id="notes"
                            maxlength="300"
                            v-model="notes"
                            name="notes"
                            type="text"
                            class="form-control"
                            :class="{ 'rolld-textarea': isRolldStore() }"
                          />
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                  <div v-if="canPayByPointsPartially">
                    <div class="form-row mt-4">
                      <div class="form-group col-sm-8">
                        <div
                          class="card shadow p-3 d-flex align-items-center"
                          style="border-radius: 10px"
                        >
                          <div
                            class="p-0 d-flex w-100 justify-content-between align-items-center"
                          >
                            <h4 class="pr-3 p-0 font-weight-bold">
                              {{ $t("message.payByLoyaltyPointsPartially") }}
                            </h4>
                            <div class="p-0 mt-1 d-flex">
                              <p
                                class="payByPoint-span py-0"
                                :class="{ 'text-success': !isRolldStore() }"
                              >
                                -{{
                                  Math.ceil(payByPoint.userPoints)
                                    | formatNumber
                                }}
                                pts ({{
                                  payByPoint.pointsValue
                                    | formatMoney(currencySign)
                                }})
                              </p>
                              <checkbox
                                style="left: 10px; padding-left: 10px"
                                id="partial-loyilty-check"
                                name="partial-loyilty-check"
                                v-model="useLoyaltyPointsBalance"
                                label=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="isChargeToRoom ? 'mt-4' : 'mt-2'"
                    v-if="showChargeToRoom()"
                  >
                    <payment-type
                      @set-payment-method="setPaymentMethod"
                      @set-show-pay-by-apple="setCanPayByApple"
                      @set-show-pay-by-google="setCanPayByGoogle"
                      :is-pay-by-cash-enable="isPayByCashEnable"
                      :is-pay-by-point-enable="payByPoint.canPay"
                      :card-value-in-point="payByPoint.cardValueInPoint"
                      :value="paymentMethod"
                      :key="PaymenttypeRender"
                    ></payment-type>
                  </div>
                  <template v-if="!onlyPayLater">
                    <div
                      v-if="
                        (canPayByApple || canPayByGoogle) && getTotalPrice > 0
                      "
                      :class="{ disableItem: SelecteDPTime() }"
                    >
                      <google-pay
                        :disabled="getDeliveryIsLoading"
                        :selected-payment-method="paymentMethod"
                        @setPaymentMethod="setPaymentMethod"
                        @finalize="finalizeStripePayment"
                        @validate="placeOrder"
                        @validateOrder="validateOrder"
                        @error="googlePaymentError"
                        @stripe-click="setMethodAndPlaceOrder"
                        @proccessing="updateProcessing"
                        ref="stripePayRef"
                      />
                    </div>
                    <div v-if="canPayByPoints">
                      <div class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                :disabled="payButtonsAreDisabled"
                                type="button"
                                @click.prevent="setMethodAndPlaceOrder(2)"
                                :class="showNewUi && 'bg-dark'"
                                class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                                :style="orderButtonStyles"
                              >
                                {{ $t("message.payByLoyaltyPoints") }} &nbsp;
                                <span
                                  class="payByPoint-span"
                                  :class="{
                                    'text-success':
                                      !isRolldStore() && !showNewUi,
                                  }"
                                >
                                  -{{
                                    Math.ceil(payByPoint.cardValueInPoint)
                                      | formatNumber
                                  }}
                                  pts ({{
                                    getTotalPrice | formatMoney(currencySign)
                                  }})
                                </span>
                                <span
                                  v-show="proccessing && paymentMethod === 2"
                                >
                                  <i class="spin-sm ml-4" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="isPayByCashEnable">
                      <div class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                :disabled="payButtonsAreDisabled"
                                type="button"
                                @click.prevent="setMethodAndPlaceOrder(3)"
                                class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                                :style="orderButtonStyles"
                              >
                                {{ $t("message.payByCash") }}
                                <span
                                  v-show="proccessing && paymentMethod === 3"
                                >
                                  <i class="spin-sm ml-4" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="getTotalPrice > 0">
                      <payment
                        ref="payment"
                        :can-pay-by-other-than-card="canPayByOtherThanCard"
                        :user="user"
                        :dbuser="userInfo"
                        :edit-model="paymentModel"
                        @save-credit="saveCredit"
                        @setPaymentMethod="setPaymentMethod"
                        :selected-payment-method="paymentMethod"
                      />
                    </div>
                    <div>
                      <div class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                :disabled="payButtonsAreDisabled"
                                type="button"
                                @click.prevent="setMethodAndPlaceOrder(1)"
                                class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                                :style="orderButtonStyles"
                              >
                                {{ $t("message.payByCard") }}
                                <span
                                  v-show="proccessing && paymentMethod == 1"
                                >
                                  <i class="spin-sm ml-4" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-if="canPayLater">
                    <div class="pt-2 mb-2">
                      <div :class="{ disableItem: SelecteDPTime() }">
                        <div class="row">
                          <div class="col-sm-12">
                            <button
                              type="button"
                              @click.prevent="payLaterButtonClicked"
                              class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                              :style="orderButtonStyles"
                            >
                              {{ payLaterButtonText }}
                              <span v-show="proccessing && paymentMethod == 8">
                                <i class="spin-sm ml-4" />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isLoyaltyMarketingEnabled && !isRolldStore()">
                    <div class="form-row mt-4">
                      <div class="form-group col-sm-12 joinourmail">
                        <input
                          type="checkbox"
                          id="joinourmail"
                          name="joinourmail"
                          value="joinourmail"
                          v-model="JoinOurMail"
                        />
                        <label for="joinourmail">Join our mailing list!</label>
                        <p class="label">
                          By signing up you are agreeing to receive information,
                          promotional material as well as exclusive offers.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-show="error" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong v-html="error"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="shopping-cart" class="col-sm-5 col-xl-4">
            <ShoppingCart
              ref="shoppingCart"
              :isFromHomePage="false"
              :proccessing="proccessing"
              :order-type="orderType"
              order-mode
            />
            <!--            <BecomeMember-->
            <!--                @setBecomeMemberResult="(result) =>{-->
            <!--                  setBecomeMember(result)-->
            <!--               }"-->
            <!--              ref="becomeMember"-->
            <!--              v-if="showBecomeMember"-->
            <!--              @close="-->
            <!--                () => {-->
            <!--                  this.showBecomeMember = false;-->
            <!--                   if(canPayLater && payLaterButtonPressed){-->
            <!--                       this.setMethodAndPlaceOrder(8);-->
            <!--                  }-->
            <!--                }-->
            <!--              "-->
            <!--            />-->
          </div>
        </div>
      </div>
    </form>
    <progressindicator
      v-if="!getloadedMenu"
      style="opacity: 0.4"
    ></progressindicator>
    <shopfooter />
    <modal
      v-if="showReorderMissingMessage"
      ref="Reordermodal"
      full-header
      @close="closeReorderModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ $t("message.reorder") }}</h2>
          </div>
          <p class="py-4">{{ $t("message.ReorderMessage") }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            :style="buttonStyles"
            data-dismiss="modal"
            type="button"
            @click="closeReorderModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <modal
      v-if="showClearCartModal"
      ref="ClearCartModal"
      full-header
      @close="closeClearCartModal"
    >
      <template slot="body">
        <div class="container">
          <p class="py-4">
            {{
              $t("message.clearCartMessage", {
                OrderType: getSelectedOrderTypeName,
              })
            }}
          </p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div
          class="w-100 d-flex gap-20 justify-content-center"
          style="z-index: 2"
        >
          <button
            class="privacy-btn mr-3"
            data-dismiss="modal"
            type="button"
            @click="cancelClearCart()"
          >
            {{ $t("message.cancel") }}
          </button>
          <button
            class="privacy-btn"
            data-dismiss="modal"
            type="button"
            @click="confirmClearCart()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <modal
      ref="privacyModal"
      v-if="payLaterPopup"
      full-header
      @close="togglePayLaterPopup"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">
              {{ currentStoreDoc.PayLaterPopupTitle }}
            </h2>
          </div>
          <p
            class="py-4 terms-and-conditions ios-scroll"
            v-html="currentStoreDoc.PayLaterPopupDescription"
          ></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            @click.prevent="setMethodAndPlaceOrder(8)"
          >
            {{ $t("message.okayGotIt") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <!--   should register account popup -->
    <modal
      ref="becomeMemberModal"
      v-if="showBecomeMember"
      full-header
      @close="() => (this.showBecomeMember = false)"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2">Register</h2>
          </div>
          <p class="py-4 text-center">
            {{ $t("message.doRegisterNewAccount") }}
          </p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div style="z-index: 2">
          <button
            class="btn btn-outline-dark pull-right"
            data-dismiss="modal"
            type="button"
            @click.prevent="saveUserAndCheckout"
          >
            {{ $t("message.register") }}
          </button>
        </div>

        <div style="z-index: 2">
          <button
            class="btn btn-outline-dark pull-right"
            data-dismiss="modal"
            type="button"
            @click.prevent="skipRegisterAndCheckout"
          >
            {{ $t("message.skip") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
    <paylater-alert :type="1" v-if="showCheckoutAlert"></paylater-alert>
    <paylater-alert :type="2" v-if="showFreqAlert"></paylater-alert>
  </div>
</template>

<script>
import MyDetail from "./partials/MyDetail";
import ShoppingCart from "./../shopping-cart/ShoppingCart";
import DeliveryAddress from "./partials/DeliveryAddress";
import Payment from "./partials/Payment";
import PickupAddress from "./partials/PickupAddress";
import RoomDelivery from "./partials/RoomDelivery";
import EatIn from "./partials/EatIn";
import ShopHeader from "./../partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import DatePicker from "vuejs-datepicker";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
// import BecomeMember from "../../../components/shop/register/BecomeMember";
import GooglePay from "./partials/GooglePay";
import { mapGetters, mapMutations } from "vuex";
import paymentType from "./paymentType";
import progressindicator from "../../progressindicator";
import PaymentIndicator from "../../shop/Checkout/partials/PaymentIndicator";
import modal from "../../modal";
import Checkbox from "../../../components/shared/checkbox.vue";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import vselect from "vue-select";
import paylaterAlert from "../../shared/paylaterAlert.vue";
import { setUpTrackingOrderListener } from "../../../api/services/orderService.js";
import uuid from "uuid/v1";
export default {
  components: {
    vselect,
    Checkbox,
    MyDetail,
    DeliveryAddress,
    Payment,
    PickupAddress,
    RoomDelivery,
    EatIn,
    ShoppingCart,
    ShopHeader,
    shopfooter,
    DatePicker,
    GooglePay,
    paymentType,
    progressindicator,
    PaymentIndicator,
    modal,
    paylaterAlert,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    forGiftCart: {
      type: Boolean,
      default: false,
    },
    orderid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showBecomeMember: false,
      becomeMemberShown: false,
      userIsExist: false,
      error: "",
      isDelivery: false,
      isPickup: false,
      isChargeToRoom: false,
      isEatIn: false,
      dtimes: [],
      pickupTimes: [],
      selectedDeliveryTime: "",
      selectedDeliveryEndTime: "",
      selectedPickupTime: "",
      selectedPickupEndTime: "",
      deliveryDate: "",
      pickupDate: "",
      startdate: "",
      notes: "",
      deliveryDisabledDates: {},
      pickupDisabledDates: {},
      showClearCartModal: false,
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null,
      },
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Latitude: "",
        Longitude: "",
      },
      roomDeliveryModel: {
        RoomNumber: "",
      },
      eatInModel: {
        TableNumber: "",
        FirstName: "",
        LastName: "",
        Email: "",
        PhoneNumber: "",
        DineInField: "",
      },
      registerNew: false,
      saveCard: false,
      JoinOurMail: false,
      paymentMethod: 1,
      deliveryDisabled: false,
      pickupDisabled: false,
      userInfo: {},
      proccessing: false,
      showPaymentIndicator: false,
      paymentSucceeded: true,
      orderObject: null,
      guestUserId: null,
      googleLoaded: false,
      stripeToken: null,
      PaymenttypeRender: 0,
      canPayByApple: false,
      canPayByGoogle: false,
      orderIdentifier: "",
      guestUserIdentifier: "",
      updateTimeListTimer: null,
      showReorderMissingMessage: false,
      useLoyaltyPointsBalance: false,
      placingPayLaterOrder: false,
      payLaterPopup: false,

      // used to check if user has clicked pay later button to skip prevent clicked twice
      payLaterButtonPressed: false,
      //  notes accordion
      notesVisible: false,
      showCheckoutAlert: false,
      showFreqAlert: false,
      unsubscribe: null
    };
  },

  computed: {
    ...shared.computed,
    ...mapGetters([
      "desktopStyles",
      "cartItems",
      "selectedCompany",
      "phoneNumber",
    ]),
    orderButtonStyles() {
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
      };
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.cartItems.length === 0
      );
    },
  },
  watch: {
    ...shared.watch,
    holder() {
      this.paymentModel.CardHolder = this.holder;
    },
    pickupDate() {
      if (this.isPickup) this.pickupSurcharge();
    },
    deliveryDate() {
      if (this.isDelivery) this.deliverySurcharge();
    },
    dbuser() {
      this.userInfo = this.dbuser;
      this.initModel();
    },

    getOrderPreparationTime() {
      this.setPickupTimes(this.pickupDate, false, this.selectedPickupTime);
    },
    getTotalPrice() {
      this.orderIdentifier = uuid();
      this.remountStripeButton();
    },
    pickupTimes() {
      this.checkStoreClosed();
    },
    dtimes() {
      this.checkStoreClosed();
    },
    selectedDeliveryTime() {
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedDeliveryTime).toISOString()
      );
    },
    selectedPickupTime() {
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedPickupTime).toISOString()
      );
    },
    useLoyaltyPointsBalance(newValue) {
      if (newValue) {
        this.setPointsDiscount(this.payByPoint.pointsValue);
      } else {
        this.setPointsDiscount(0);
      }
    },
    payByPoint: {
      deep: true,
      handler(newValue) {
        if (newValue.canPay) {
          this.useLoyaltyPointsBalance = false;
        }
        if (this.useLoyaltyPointsBalance) {
          this.setPointsDiscount(this.payByPoint.pointsValue);
        }
      },
    },
  },
  created() {
    this.setRoomNoFromStorage();
  },
  async mounted() {
    await shared.mounted(true, this);

    setUpTrackingOrderListener(this);

    if (this.phoneNumber) {
      this.detailModel.Phone = this.phoneNumber;
    }

    const deliveryAddress = JSON.parse(
      sessionStorage.getItem("deliveryAddress")
    );
    if (deliveryAddress) {
      this.deliveryAddressModel = deliveryAddress;
    }

    const pickupTime = sessionStorage.getItem("deliveryTime");
    if (pickupTime) {
      this.selectedPickupTimeChange(pickupTime);
    }
    this.checkOrderFreq();
  },
  beforeRouteEnter(to, from, next) {
    shared.beforeRouteEnter(to, from, next);
  },
  methods: {
    ...shared.methods,
    ...mapMutations(["setShowOverlay"]),
    setCanPayByApple(flag) {
      this.canPayByApple = flag;
    },

    timeSlotsClick(timeSlot) {
      this.selectedDeliveryTime = timeSlot.time;
      this.selectedDeliveryEndTime = timeSlot.to;
    },
    setCanPayByGoogle(flag) {
      this.canPayByGoogle = flag;
    },
    getCheckoutRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.desktopStyles.primaryBodyBackground);
      }
      return styles;
    },
    closeReorderModal() {
      this.$refs.Reordermodal.hideModal();
      this.showReorderMissingMessage = false;
    },

    closeClearCartModal() {
      this.$refs.ClearCartModal.hideModal();
      this.showClearCartModal = false;
      this.cancelClearCart();
    },

    // setBecomeMember(result) {
    //   this.setBecomeMemberResult(result)
    //   this.showBecomeMember = false;
    //   if(this.canPayLater && this.payLaterButtonPressed){
    //     this.setMethodAndPlaceOrder(8);
    //   }
    // },
  },
  destroyed() {
    shared.destroyed();
  },
  beforeDestroy() {
    shared.beforeDestroy(this);
  }
};
</script>
